import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { useVariableLoadedListener } from 'hooks/useVariableLoadedListener'
import { forwardRef, useEffect, useRef } from 'react'
import styled from 'styled-components'

const NotificationBarContainer = forwardRef<HTMLDivElement, BoxProps>(({ children, ...props }, ref) => {
  return (
    <StyledContainer ref={ref} position="relative" width="100%" {...props}>
      {children}
    </StyledContainer>
  )
})

export const NotificationBarAutoHiddenContainer: React.FC<BoxProps> = ({ children, ...props }) => {
  const refElement = useRef(null)

  const refElementInstance = useVariableLoadedListener(() => {
    const instance = typeof document !== 'undefined' && refElement.current
    return instance
  })

  useEffect(() => {
    if (!refElementInstance) return

    window.addEventListener('scroll', handleDetectScroll)

    return () => {
      window.removeEventListener('scroll', handleDetectScroll)
    }
  }, [refElementInstance])

  const handleDetectScroll = () => {
    if (!refElementInstance) return

    const root = document.querySelector(':root') as any

    const top = window.pageYOffset || document.documentElement.scrollTop
    const barIsHide = refElement.current?.classList.contains('hide')
    const POSITION_SCROLL = 40
    if (top > POSITION_SCROLL) {
      if (!barIsHide) {
        refElement.current.classList.add('hide')
        root.style.setProperty('--notification-bar-height', '0px')
      }
    } else {
      refElement.current.classList.remove('hide')
      root.style.setProperty('--notification-bar-height', '40px')
    }
  }

  return (
    <NotificationBarContainer ref={refElement} {...props}>
      {children}
    </NotificationBarContainer>
  )
}

const StyledContainer = styled(Box)`
  background: #3b0099;
  height: var(--notification-bar-height);
  transition: 0.1s;
  z-index: ${({ theme }) => theme.zIndices.menu};

  &.hide {
    height: 0px;
    overflow: hidden;
  }
`

export default NotificationBarContainer
